import { enumText, getText } from '../enum/Base';

export namespace ClaimTypes {
  export const organizationId = "Spread.App.ClaimTypes.OrganizationId";
  // export const hasActiveMembership = "Spread.App.ClaimTypes.HasActiveMembership";
}

// export default ClaimTypes;